import { css } from 'linaria';
import { Variables } from '../index';

export const theme = css`
    :global() {
        [data-theme='light'] {
            --checkbox-border-color: ${Variables.css.grey3};
            --checkbox-checked-background: ${Variables.css.catapultBlack};
            --checkbox-unchecked-background: ${Variables.css.catapultWhite};
            --checkbox-checked-tick: ${Variables.css.catapultWhite};
            --checkbox-pressed: var(--r-focus-overlay);
            --checkbox-alert: ${Variables.css.alert};
            --checkbox-focus: ${Variables.css.focusRing};
        }

        [data-theme='dark'] {
            --checkbox-border-color: ${Variables.css.catapultWhite};
            --checkbox-checked-background: ${Variables.css.catapultWhite};
            --checkbox-unchecked-background: ${Variables.css.catapultBlack};
            --checkbox-checked-tick: ${Variables.css.catapultBlack};
            --checkbox-pressed: var(--r-focus-overlay);
            --checkbox-alert: ${Variables.css.alert};
            --checkbox-focus: ${Variables.css.focusRing};
        }
    }
`;

export const fauxCheckbox = css`
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
    background: var(--checkbox-unchecked-background);
`;

export const label = css`
    position: relative;
    top: 1px;
`;
export const checkbox = css`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 20px;
    width: 20px;
    min-height: 20px;
    min-width: 20px;
    border-radius: 2px;
    position: relative;
    transition: all 0.2s ease-in;
    background: var(--checkbox-checked-background);

    .${fauxCheckbox}:not(:disabled):hover:not([aria-invalid]) + & {
        box-shadow: 0 0 0 2px var(--checkbox-checked-background) inset;
        cursor: pointer;
    }

    .${fauxCheckbox}:not(:disabled):focus-visible + & {
        box-shadow: 0 0 0 1px var(--checkbox-border-color) inset, 0 0 0 2px var(--checkbox-focus);
    }

    .${fauxCheckbox}[aria-invalid] + & {
        --checkbox-border-color: var(--checkbox-alert);
        box-shadow: 0 0 0 2px var(--checkbox-border-color) inset;
    }

    .${fauxCheckbox}:disabled + &,
    .${fauxCheckbox}:disabled ~ .${label} {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const unchecked = css`
    background: var(--checkbox-unchecked-background);
    box-shadow: 0 0 0 1px var(--checkbox-border-color) inset;
`;

export const root = css`
    display: inline-flex;
    align-items: center;
    gap: ${Variables.css.spacing8};
`;

export const icon = css`
    height: 16px;
    width: 16px;
    border-radius: 2px;
    position: absolute;
    object-fit: contain;
    color: var(--checkbox-checked-tick);
}`;
